var Afterpay = {
	supportedTheme: !1,
	mutationObserver: !1
};
Afterpay.arrayContainsElement = function (t, e) {
	var a;
	if (Array.prototype.indexOf) return t.indexOf(e) > -1;
	for (a = 0; a < t.length; a++)
		if (t[a] == e) return !0;
	return !1
}, Afterpay.closePopup = function (t, e) {
	e.preventDefault(), t("#afterpay-popup-wrapper").hide()
}, Afterpay.commonElements = {
	product: {
		price_selector: ["#ProductPrice", "#product-price", "#ProductSection .product-single__prices", ".product-details .product-price", ".product--container .product-pricing", ".productForm .product-price", ".product-single__meta .product__price", ".product__content .product__price", "p.modal_price", "ul.product-meta", "ul.product-single__meta-list", ".product-single__price", ".product-single__prices", ".product__price"]
	},
	cart: {
		static_page: {
			subtotal_selector: ["#CartSubtotal", "form .subtotal_amount", ".cart__footer .cart__subtotal", ".cart-footer .cart-footer__subtotal", "span.cart__subtotal", ".h1.cart-subtotal--price", ".cart__row--table:last"]
		}
	}
}, Afterpay.extractPriceFromHTML = function (t) {
	var e = t.replace(/[^0-9.]/g, "");
	return Math.round(100 * parseFloat(e))
}, Afterpay.generateCurrencyHTML = function (t) {
	var e = Math.round(t, 2).toFixed(2);
	return afterpay_show_currency_code ? "$" + e + "&nbsp;" + afterpay_shop_currency.toUpperCase() : "$" + e
}, Afterpay.generateInsideLimitHTML = function (t) {
	return "Interest-free installments by " == t.find(".afterpay-text1").html() && (Afterpay.supportedTheme ? t.find(".afterpay-text1").html("or 4 interest-free installments of ") : t.find(".afterpay-text1").html("Pay in 4 interest-free installments of "), t.find(".afterpay-logo").insertAfter(t.find(".afterpay-instalments")), t.find(".afterpay-text2").html(" by ").insertBefore(t.find(".afterpay-logo")), t.find(".afterpay-link-inner").html("More info")), t
}, Afterpay.generateInstalmentHTML = function (t) {
	var e = (Math.round(t / 4) / 100).toFixed(2);
  	return afterpay_show_currency_code ? "$" + e : "$" + e
// 	return afterpay_show_currency_code ? "$" + e + "&nbsp;" + afterpay_shop_currency.toUpperCase() : "$" + e
}, Afterpay.generateOutsideLimitHTML = function (t) {
	return t.find(".afterpay-text1").html("Interest-free installments by "), t.find(".afterpay-logo").insertAfter(t.find(".afterpay-text1")), t.find(".afterpay-text2").html(" available between "), t.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_min) + " - " + Afterpay.generateCurrencyHTML(afterpay_max)).insertAfter(t.find(".afterpay-text2")), t.find(".afterpay-link-inner").html("Learn more"), t
}, Afterpay.init = function (t) {
	Afterpay.supportedTheme = Afterpay.supportedThemes[afterpay_theme_name.toLowerCase()], Afterpay.mutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	/^\/cart/i.test(window.location.pathname) ? 0 != afterpay_cart_integration_enabled && Afterpay.initStaticCartPage(t) : /^\/(collections|products)/i.test(window.location.pathname) && afterpay_product && Afterpay.initProductPage(t), 0 != afterpay_cart_integration_enabled && Afterpay.supportedTheme && Afterpay.supportedTheme.hasOwnProperty("cart") && Afterpay.supportedTheme.cart.hasOwnProperty("dynamic_content") && t.each(Afterpay.supportedTheme.cart.dynamic_content, function (e, a) {
		a.hasOwnProperty("target_selector") && a.hasOwnProperty("addedNode_selector") && a.hasOwnProperty("subtotal_selector") && (Afterpay.mutationObserver && new Afterpay.mutationObserver(function (e, r) {
			var p, o;
			for (p = 0; p < e.length; p++)
				if (Afterpay.supportedTheme && t(e[p].target).is(a.target_selector))
					for (o = 0; o < e[p].addedNodes.length; o++)
						if ("object" == typeof e[p].addedNodes[o] && t(e[p].addedNodes[o]).is(a.addedNode_selector)) {
							var c = Afterpay.renderParagraph(t, {
								total_price: afterpay_cart_total_price
							});
							"USD" != afterpay_shop_currency && (c.find(".afterpay-text1").html("or 4 payments of "), c.find(".afterpay-text2").html(" with ")), (afterpay_cart_total_price < 100 * afterpay_min || afterpay_cart_total_price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? (c.find(".afterpay-text1").html("Interest-free installments by "), c.find(".afterpay-logo").insertAfter(c.find(".afterpay-text1")), c.find(".afterpay-text2").html(" available between "), c.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_min) + " - " + Afterpay.generateCurrencyHTML(afterpay_max)).insertAfter(c.find(".afterpay-text2")), c.find(".afterpay-link-inner").html("Learn more")) : c.hide()), "undefined" != typeof afterpay_cart_dynamic_css && c.css(afterpay_cart_dynamic_css), t(a.target_selector).find(a.addedNode_selector).find(a.subtotal_selector).after(c), a.paragraph_css && c.css(a.paragraph_css), "function" == typeof a.after_render && a.after_render(t, c)
						}
		}).observe(document, {
			childList: !0,
			attributes: !1,
			characterData: !1,
			subtree: !0,
			attributeOldValue: !1,
			characterDataOldValue: !1
		}), t(document).ajaxComplete(function (e, r, p) {
			if ("/cart" == p.url) {
				var o = t(r.responseText).find(a.subtotal_selector).find("span.visually-hidden");
				if (o.length > 0) {
					var c = o.text(),
						n = Number(c.replace(/[^0-9]/g, ""));
					afterpay_cart_total_price = n
				}
			} else if ("/cart/change.js" == p.url && 200 == r.status && "OK" == r.statusText) {
				n = r.responseJSON.total_price;
				afterpay_cart_total_price = n
			}
		}))
	})
}, Afterpay.initProductPage = function (t) {
	var e, a = null,
		r = null,
		p = null,
		o = "after";
	e = Afterpay.renderParagraph(t, {
		total_price: afterpay_current_variant.price
	}), "undefined" != typeof afterpay_product_selector ? (Afterpay.supportedTheme = !0, (a = t(afterpay_product_selector)).length > 0 && (r = a.first())) : (Afterpay.supportedTheme ? t.each(Afterpay.supportedTheme.product, function (p, o) {
		if ((a = t(o.selector)).length > 0) return r = a.first(), o.paragraph_css && e.css(o.paragraph_css), !1
	}) : (a = null, t.each(Afterpay.supportedThemes, function (p, o) {
		if (new RegExp(p, "i").test(afterpay_theme_name) && (t.each(Afterpay.supportedThemes[p].product, function (o, c) {
				if ((a = t(c.selector)).length > 0) return Afterpay.supportedTheme = Afterpay.supportedThemes[p], r = a.first(), c.paragraph_css && e.css(c.paragraph_css), !1
			}), null !== r)) return !1
	})), null === r && t.each(Afterpay.commonElements.product.price_selector, function (e, p) {
		if ((a = t(p)).length > 0) return Afterpay.supportedTheme = !0, r = a.first(), !1
	}), null === r && (a = t('form[action^="/cart/add"]')).length > 0 && (r = a.first(), o = "before", "USD" == afterpay_shop_currency ? e.find(".afterpay-text1").html("Pay in 4 interest-free installments of ") : e.find(".afterpay-text1").html("Make 4 interest-free payments of "))), null !== r && (afterpay_current_variant.available ? (afterpay_current_variant.price < 100 * afterpay_min || afterpay_current_variant.price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? e = Afterpay.generateOutsideLimitHTML(e) : e.hide()) : e.hide(), "undefined" != typeof afterpay_product_css && e.css(afterpay_product_css), r[o](e)), 0 != afterpay_variable_price_fallback ? ("undefined" != typeof afterpay_variable_price_fallback_selector && (a = t(afterpay_variable_price_fallback_selector)).length > 0 && (p = a.first()), null === p && null !== r && (p = r), null !== p && (Afterpay.mutationObserver ? (Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(p.text())), new Afterpay.mutationObserver(function (a, r) {
		var o;
		for (p = t(afterpay_variable_price_fallback_selector).first(), o = 0; o < a.length; o++) t(a[o].target).is(p) && Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(a[o].target.innerHTML))
	}).observe(document.body, {
		childList: !0,
		attributes: !1,
		characterData: !1,
		subtree: !0,
		attributeOldValue: !1,
		characterDataOldValue: !1
	})) : setInterval(function (a) {
		p = t(afterpay_variable_price_fallback_selector).first(), Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(p.text()))
	}, 400))) : t("body").on("change", t('form[action^="/cart/add"]'), function (a) {
		var r = t(a.target).closest("form"),
			p = parseInt(t("input[name=id]:checked, select[name=id], input[name=id], hidden[name=id]", r).val(), 10),
			o = !1;
		!isNaN(p) && p > 0 && t.each(afterpay_product.variants, function (t, a) {
			a.id == p && a.available && (a.price >= 100 * afterpay_min && a.price <= 100 * afterpay_max ? (o = !0, "USD" == afterpay_shop_currency && (e = Afterpay.generateInsideLimitHTML(e)), e.find(".afterpay-instalments").html(Afterpay.generateInstalmentHTML(a.price))) : "USD" == afterpay_shop_currency && (o = !0, e = Afterpay.generateOutsideLimitHTML(e)))
		}), r.find("input[type=submit],button[type=submit]").is("[disabled]") && (o = !1), null !== e && (o ? e.show() : e.hide())
	})
}, Afterpay.initStaticCartPage = function (t) {
	var e, a = null,
		r = null,
		p = null,
		o = "after";
	e = Afterpay.renderParagraph(t, {
		total_price: afterpay_cart_total_price
	}), "undefined" != typeof afterpay_cart_static_selector ? (Afterpay.supportedTheme = !0, (a = t(afterpay_cart_static_selector)).length > 0 && (r = a.first(), "USD" != afterpay_shop_currency && (e.find(".afterpay-text1").html("or 4 payments of "), e.find(".afterpay-text2").html(" with ")))) : (Afterpay.supportedTheme ? t.each(Afterpay.supportedTheme.cart.static_page, function (p, o) {
		if (a = t(o.selector), o.paragraph_css && e.css(o.paragraph_css), a.length > 0) return r = a.first(), "USD" != afterpay_shop_currency && (e.find(".afterpay-text1").html("or 4 payments of "), e.find(".afterpay-text2").html(" with ")), !1
	}) : (a = null, t.each(Afterpay.supportedThemes, function (p, o) {
		if (new RegExp(p, "i").test(afterpay_theme_name) && (t.each(Afterpay.supportedThemes[p].cart.static_page, function (o, c) {
				if (a = t(c.selector), c.paragraph_css && e.css(c.paragraph_css), a.length > 0) return Afterpay.supportedTheme = Afterpay.supportedThemes[p], r = a.first(), "USD" != afterpay_shop_currency && (e.find(".afterpay-text1").html("or 4 payments of "), e.find(".afterpay-text2").html(" with ")), !1
			}), null !== r)) return !1
	})), null === r && t.each(Afterpay.commonElements.cart.static_page.subtotal_selector, function (p, o) {
		if ((a = t(o)).length > 0) return Afterpay.supportedTheme = !0, r = a.first(), "USD" != afterpay_shop_currency && (e.find(".afterpay-text1").html("or 4 payments of "), e.find(".afterpay-text2").html(" with ")), !1
	}), null === r && (e.css({
		"text-align": "right"
	}), "USD" == afterpay_shop_currency ? e.find(".afterpay-text1").html("Pay in 4 interest-free installments of ") : e.find(".afterpay-text1").html("Make 4 payments of "), (a = t('a[href="collections/all"],input[name=update]')).length > 0 ? (r = a.first(), o = "before") : (a = t('form[action^="/cart"]:not(form[action^="/cart/add"])')).length > 0 && (r = a.first()))), null !== r && ((afterpay_cart_total_price < 100 * afterpay_min || afterpay_cart_total_price > 100 * afterpay_max) && ("USD" == afterpay_shop_currency ? (e.find(".afterpay-text1").html("Interest-free installments by "), e.find(".afterpay-logo").insertAfter(e.find(".afterpay-text1")), e.find(".afterpay-text2").html(" available between "), e.find(".afterpay-instalments").html(Afterpay.generateCurrencyHTML(afterpay_min) + " - " + Afterpay.generateCurrencyHTML(afterpay_max)).insertAfter(e.find(".afterpay-text2")), e.find(".afterpay-link-inner").html("Learn more")) : e.hide()), "undefined" != typeof afterpay_cart_static_css && e.css(afterpay_cart_static_css), r[o](e)), 0 != afterpay_variable_subtotal_fallback && ("undefined" != typeof afterpay_variable_subtotal_fallback_selector && (a = t(afterpay_variable_subtotal_fallback_selector)).length > 0 && (p = a.first()), null === p && null !== r && (p = r), null !== p && (Afterpay.mutationObserver ? (Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(p.text())), dom_mutation_observer = new Afterpay.mutationObserver(function (a, r) {
		var o;
		for (p = t(afterpay_variable_subtotal_fallback_selector).first(), o = 0; o < a.length; o++) t(a[o].target).is(p) && Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(a[o].target.innerHTML))
	}), dom_mutation_observer.observe(p.get(0), {
		childList: !0,
		attributes: !1,
		characterData: !1,
		subtree: !0,
		attributeOldValue: !1,
		characterDataOldValue: !1
	})) : setInterval(function (a) {
		p = t(afterpay_variable_subtotal_fallback_selector).first(), Afterpay.updateParagraph(e, Afterpay.extractPriceFromHTML(p.text()))
	}, 400)))
}, Afterpay.launchPopup = function (t, e) {
	if (e.preventDefault(), afterpay_modal_responsive && "USD" == afterpay_shop_currency)
		if (t("#afterpay-modal-container").length) t("body").addClass("afterpay-modal-open"), t("#afterpay-modal-modal").scrollTop(0);
		else {
			var a = t(document.createElement("link"));
			a.attr("rel", "stylesheet").attr("type", "text/css").attr("href", "https://static.afterpay.com/modal/us.css").appendTo("head"), t.ajax({
				url: "https://static.afterpay.com/modal/us.html",
				complete: function (r, p) {
					200 == r.status ? (t("body").addClass("afterpay-modal-open").append(r.responseText), t("#afterpay-afterpay-modal-close").on("click", function (e) {
						e.preventDefault(), t("body").removeClass("afterpay-modal-open")
					})) : (a.remove(), afterpay_modal_responsive = !1, Afterpay.launchPopup(t, e))
				}
			})
		}
	else {
		var r, p, o, c, n;
		(r = t("#afterpay-popup-wrapper")).length > 0 ? r.show() : (r = t(document.createElement("div")).attr("id", "afterpay-popup-wrapper").css({
			position: "fixed",
			"z-index": 9999999999,
			left: 0,
			top: 0,
			right: 0,
			bottom: 0,
			overflow: "auto"
		}).appendTo("body").on("click", function (e) {
			Afterpay.closePopup(t, e)
		}), p = t(document.createElement("div")).attr("id", "afterpay-popup-outer").css({
			display: "-ms-flexbox",
			display: "-webkit-flex",
			display: "flex",
			"-webkit-justify-content": "center",
			"-ms-flex-pack": "center",
			"justify-content": "center",
			"-webkit-align-content": "center",
			"-ms-flex-line-pack": "center",
			"align-content": "center",
			"-webkit-align-items": "center",
			"-ms-flex-align": "center",
			"align-items": "center",
			width: "100%",
			"min-height": "100%",
			"background-color": "rgba(0, 0, 0, 0.80)"
		}).appendTo(r), o = t(document.createElement("div")).attr("id", "afterpay-popup-inner").css({
			position: "relative",
			"background-color": "#fff"
		}).appendTo(p), c = t(document.createElement("a")), "USD" == afterpay_shop_currency ? c.attr("href", "https://www.afterpay.com/purchase-payment-agreement") : c.attr("href", "https://www.afterpay.com/terms"), c.attr("target", "_blank").css({
			display: "block"
		}).appendTo(o), n = t(document.createElement("img")), "USD" == afterpay_shop_currency ? t(window).width() > 640 ? n.attr("src", "https://static.afterpay.com/us-popup-medium.png").attr("srcset", "https://static.afterpay.com/us-popup-medium.png 1x, https://static.afterpay.com/us-popup-medium@2x.png 2x").css({
			"max-width": "597px"
		}) : n.attr("src", "https://static.afterpay.com/us-popup-small.png").attr("srcset", "https://static.afterpay.com/us-popup-small.png 1x, https://static.afterpay.com/us-popup-small@2x.png 2x").css({
			"max-width": "299px"
		}) : t(window).width() > 640 ? n.attr("src", "https://static.afterpay.com/lightbox-desktop.png") : n.attr("src", "https://static.afterpay.com/lightbox-mobile.png"), n.css({
			display: "block",
			width: "100%"
		}).appendTo(c).on("click", function (t) {
			t.stopPropagation()
		}), t(document.createElement("a")).attr("href", "#").css({
			position: "absolute",
			right: "8px",
			top: "8px"
		}).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="32px" height="32px"><g id="surface1"><path style=" " d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z "/></g></svg>').appendTo(o).on("click", function (e) {
			Afterpay.closePopup(t, e)
		}))
	}
}, Afterpay.loadScript = function (t, e) {
	var a = document.createElement("script");
	a.type = "text/javascript", a.readyState ? a.onreadystatechange = function () {
		"loaded" != a.readyState && "complete" != a.readyState || (a.onreadystatechange = null, e())
	} : a.onload = function () {
		e()
	}, a.src = t, document.getElementsByTagName("head")[0].appendChild(a)
}, Afterpay.renderParagraph = function (t, e) {
	var a = t(document.createElement("p")).addClass("afterpay-paragraph");
	null !== afterpay_product && a.attr("data-product-id", afterpay_product.id);

  
  	var o = t(document.createElement("a")).addClass("afterpay-link");
	"USD" == afterpay_shop_currency ? o.attr("href", "https://www.afterpay.com/purchase-payment-agreement") : o.attr("href", "https://www.afterpay.com/terms"), o.attr("target", "_blank").on("click", function (e) {
		Afterpay.launchPopup(t, e)
	}).appendTo(a);
  
  
  	t(document.createElement("img")).addClass("afterpay-logo").css({
		"vertical-align": "middle",
		width: "200px"
	}).attr("src", "https://cdn.shopify.com/s/files/1/2303/2711/files/afterpay-logo.svg").attr("srcset", "https://cdn.shopify.com/s/files/1/2303/2711/files/afterpay-logo.svg 1x, https://cdn.shopify.com/s/files/1/2303/2711/files/afterpay-logo.svg 2x, https://cdn.shopify.com/s/files/1/2303/2711/files/afterpay-logo.svg 3x").attr("width", "200").attr("height", "40").attr("alt", "Afterpay").appendTo(o);
    
  	var oo = t(document.createElement("div")).addClass("afterpay-text");
  
  	oo.appendTo(o);
  
    t(document.createElement("span")).addClass("afterpay-text3").html(" ").appendTo(oo);
  
  	var r = t(document.createElement("span")).addClass("afterpay-text1").appendTo(oo);
	"USD" == afterpay_shop_currency ? r.html("4 payments of ") : r.html("4 payments of ");
	t(document.createElement("span")).addClass("afterpay-instalments").html(Afterpay.generateInstalmentHTML(e.total_price)).appendTo(oo);
	var p = t(document.createElement("span")).addClass("afterpay-text2").appendTo(oo);
	"USD" == afterpay_shop_currency ? p.html(" ") : p.html(" ");
//   "USD" == afterpay_shop_currency ? p.html(" by ") : p.html(" fortnightly with ");
	
  
// 	t(document.createElement("u")).addClass("afterpay-link-inner").css({
// 		"font-size": "12px"
//       }).html("More info").appendTo(o);
  
	return a
}, Afterpay.supportedCurrencies = ["AUD", "NZD", "USD"], Afterpay.supportedThemes = {
	alchemy: {
		product: {
			"2017-12-14": {
				selector: ".quadd-wrapper"
			}
		}
	},
	atlantic: {
		product: {
			"2017-12-14": {
				selector: "p.price"
			}
		}
	},
	blockshop: {
		product: {
			"2017-12-14": {
				selector: "article .prices",
				paragraph_css: {
					"margin-top": "-1em",
					"margin-bottom": "2em"
				}
			}
		}
	},
	boundless: {
		product: {
			"2017-12-14": {
				selector: "#AddToCartForm-product-template .product__price",
				paragraph_css: {
					"margin-top": "-20px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: "span.cart__subtotal"
				}
			}
		}
	},
	brooklyn: {
		product: {
			"2017-12-14": {
				selector: "#ProductPrice"
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".cart__row--table:last"
				}
			},
			dynamic_content: {
				"2018-06-25": {
					target_selector: "#CartDrawer #CartContainer",
					addedNode_selector: "form.ajaxcart",
					subtotal_selector: ".ajaxcart__footer .grid--full",
					paragraph_css: {
						"text-align": "right"
					},
					after_render: function (t, e) {
						var a = t("#CartContainer .ajaxcart__inner--has-fixed-footer"),
							r = t("#CartContainer .ajaxcart__footer--fixed"),
							p = r.outerHeight() + e.outerHeight(!0);
						a.css("bottom", p + "px"), r.css("height", p + "px")
					}
				}
			}
		}
	},
	classic: {
		product: {
			"2017-12-14": {
				selector: ".product-single__prices",
				paragraph_css: {
					"margin-top": "-15px",
					"margin-bottom": "30px"
				}
			}
		}
	},
	debut: {
		product: {
			"2017-12-14": {
				selector: ".product-single__price",
				paragraph_css: {
					"margin-top": "-20px",
					"margin-bottom": "40px"
				}
			},
			"2018-07-04": {
				selector: ".product__price",
				paragraph_css: {
					"margin-top": "-10px",
					"margin-bottom": "40px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".cart__footer .cart__subtotal"
				}
			}
		}
	},
	district: {
		product: {
			"2017-12-14": {
				selector: "#ComparePrice-product-template",
				paragraph_css: {
					"margin-top": "0.3rem",
					display: "block",
					"font-style": "normal"
				}
			}
		}
	},
	empire: {
		product: {
			"2017-12-14": {
				selector: ".product--container .product-pricing",
				paragraph_css: {
					"line-height": "1.5",
					"margin-top": "10px",
					"margin-bottom": "22px"
				}
			}
		}
	},
	fashionopolism: {
		product: {
			"2017-12-14": {
				selector: ".product-prices"
			},
			"2018-08-10": {
				selector: "#product-price"
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#basket-right>h4"
				}
			}
		}
	},
	flow: {
		product: {
			"2017-12-14": {
				selector: "#ProductPrice",
				paragraph_css: {
					"margin-top": "-20px",
					"margin-bottom": "30px"
				}
			}
		}
	},
	grid: {
		product: {
			"2017-12-14": {
				selector: ".product-details .product-price",
				paragraph_css: {
					"margin-top": "-35px",
					"margin-bottom": "40px"
				}
			}
		}
	},
	icon: {
		product: {
			"2017-12-14": {
				selector: "#product-price",
				paragraph_css: {
					"margin-top": "-20px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#basket-right>h4"
				}
			}
		}
	},
	jumpstart: {
		product: {
			"2017-12-14": {
				selector: "#AddToCartForm .price:last"
			},
			"2018-05-30": {
				selector: "#ProductPrice-product-template"
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: "span.h3.cart__subtotal"
				}
			}
		}
	},
	minimal: {
		product: {
			"2017-12-14": {
				selector: ".product-single__prices",
				paragraph_css: {
					"margin-top": "-15px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".h5.cart__subtotal"
				}
			}
		}
	},
	modular: {
		product: {
			"2017-12-14": {
				selector: ".productForm .product-price",
				paragraph_css: {
					"margin-top": "-1rem",
					"margin-bottom": "1.5rem"
				}
			}
		}
	},
	motion: {
		product: {
			"2017-12-14": {
				selector: ".product-single__meta .product__price:last"
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".grid--full.cart__row--table:last",
					paragraph_css: {
						"margin-top": "10px"
					}
				}
			}
		}
	},
	narrative: {
		product: {
			"2017-12-14": {
				selector: ".product__content .product__price",
				paragraph_css: {
					"margin-top": "-10px",
					"text-align": "center"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".cart-footer .cart-footer__subtotal"
				}
			}
		}
	},
	pacific: {
		product: {
			"2017-12-14": {
				selector: ".product-price"
			}
		}
	},
	parallax: {
		product: {
			"2017-12-14": {
				selector: ".modal_price"
			}
		},
		cart: {
			static_page: {
				"2018-05-31": {
					selector: "form .subtotal_amount",
					paragraph_css: {
						"font-size": "13px"
					}
				}
			}
		}
	},
	pipeline: {
		product: {
			"2017-12-14": {
				selector: "#ComparePriceWrapper-product",
				paragraph_css: {
					"margin-top": "15px",
					"line-height": "1.5",
					"letter-spacing": "0",
					"font-size": "14px",
					"text-transform": "none",
					color: "#000"
				}
			},
			"2018-08-10": {
				selector: "#productInfo-product .product__price"
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: ".cart__footer__text:first"
				}
			}
		}
	},
	pop: {
		product: {
			"2017-12-14": {
				selector: ".product-single__price"
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: "span.cart__subtotal"
				}
			}
		}
	},
	prestige: {
		product: {
			"2018-07-27": {
				selector: ".ProductMeta__PriceList.Heading"
			}
		}
	},
	providence: {
		product: {
			"2017-12-14": {
				selector: ".pricing"
			}
		}
	},
	retina: {
		product: {
			"2017-12-14": {
				selector: ".modal_price",
				paragraph_css: {
					"margin-top": "-15px",
					"margin-bottom": "20px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#cart_form .subtotal_amount",
					paragraph_css: {
						"font-size": "13px"
					}
				}
			}
		}
	},
	showcase: {
		product: {
			"2018-08-10": {
				selector: ".product-detail__title-and-price .price-area"
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#cartform .subtotal"
				}
			}
		}
	},
	showtime: {
		product: {
			"2017-12-14": {
				selector: ".desc_blk_bot .price",
				paragraph_css: {
					float: "none",
					clear: "both",
					"margin-bottom": "1rem",
					"text-align": "center"
				}
			}
		}
	},
	simple: {
		product: {
			"2017-12-14": {
				selector: "#ProductSection .product-single__prices",
				paragraph_css: {
					"margin-top": "-15px",
					"margin-bottom": "30px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: "span.cart__subtotal.h3"
				}
			}
		}
	},
	supply: {
		product: {
			"2017-12-14": {
				selector: "ul.product-meta"
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: ".h1.cart-subtotal--price"
				}
			},
			dynamic_content: {
				"2018-05-30": {
					target_selector: "#ajaxifyCart.ajaxifyCart--content",
					addedNode_selector: "form.cart-form",
					subtotal_selector: ".h1.cart-subtotal--price"
				}
			}
		}
	},
	symmetry: {
		product: {
			"2017-12-14": {
				selector: "#main-product-detail .price-area"
			}
		}
	},
	testament: {
		product: {
			"2017-12-14": {
				selector: "#product-price"
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#basket-right>h4"
				}
			}
		}
	},
	turbo: {
		product: {
			"2018-08-10": {
				selector: ".modal_price"
			}
		},
		cart: {
			static_page: {
				"2018-08-10": {
					selector: "#cart_form .cart_subtotal"
				}
			}
		}
	},
	venture: {
		product: {
			"2017-12-14": {
				selector: "ul.product-single__meta-list",
				paragraph_css: {
					"margin-top": "10px"
				}
			}
		},
		cart: {
			static_page: {
				"2018-05-30": {
					selector: "p#CartSubtotal"
				}
			}
		}
	},
	venue: {
		product: {
			"2017-12-14": {
				selector: "h3.product-single__price-text",
				paragraph_css: {
					"line-height": "1.5"
				}
			}
		}
	}
}, Afterpay.updateParagraph = function (t, e) {
	e >= 100 * afterpay_min && e <= 100 * afterpay_max ? (t.show(), "USD" == afterpay_shop_currency && (t = Afterpay.generateInsideLimitHTML(t)), t.find(".afterpay-instalments").html(Afterpay.generateInstalmentHTML(e))) : "USD" == afterpay_shop_currency ? (t.show(), t = Afterpay.generateOutsideLimitHTML(t)) : t.hide()
};
var afterpay_js_include_version = "1.5.2";
if (void 0 === afterpay_cart_integration_enabled) {
	var afterpay_cart_integration_enabled;
	afterpay_cart_integration_enabled = "USD" == afterpay_shop_currency
}
if (void 0 === afterpay_variable_price_fallback)
	if ("undefined" == typeof afterpay_variable_price_fallback_selector) var afterpay_variable_price_fallback = !1;
	else afterpay_variable_price_fallback = !0;
if (void 0 === afterpay_variable_subtotal_fallback)
	if ("undefined" == typeof afterpay_variable_subtotal_fallback_selector) var afterpay_variable_subtotal_fallback = !1;
	else afterpay_variable_subtotal_fallback = !0;
if (void 0 === afterpay_modal_responsive) var afterpay_modal_responsive = !1;
if (void 0 === afterpay_show_currency_code) var afterpay_show_currency_code = !0;
"USD" == afterpay_shop_currency ? afterpay_min = Math.max(afterpay_min, 35) : afterpay_min = Math.max(afterpay_min, .04), Afterpay.arrayContainsElement(Afterpay.supportedCurrencies, afterpay_shop_currency) && ("function" != typeof jQuery || !Object.prototype.hasOwnProperty.call(jQuery, "fn") || parseFloat(jQuery.fn.jquery) < 1.7 ? Afterpay.loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js", function () {
	var t = jQuery.noConflict(!0);
	Afterpay.init(t)
}) : Afterpay.init(jQuery));
